module.exports = __webpack_public_path__ + "static/media/bubble-exit.ecf1a722.webm";